type BASIS = 'Завод';

export enum ProductGroupName {
  REG = 'REG',
  PRM = 'PRM',
  DTL = 'DTL',
  DTM = 'DTM',
  DTZ = 'DTZ',
  TRD = 'TRD',
  MZT = 'MZT',
  SUG = 'SUG',
  DTA = 'DTA',
  GKS = 'GKS',
  SPR = 'SPR',
  I00 = '100',
  OIL = 'OIL',
}

export type AllTableColumn = {
  name: ProductGroupName | BASIS;
};

export type AllTableSorting = {
  columnName: ProductGroupName | BASIS;
  direction: 'ASC' | 'DES';
};
